<div class="lgpd-overlay" *ngIf="show">
  <div class="lgpd-modal">
    <h2>Cookies & Privacidade</h2>

    <p>
      Usamos apenas cookies essenciais e cookies do Google Analytics.
      Para saber mais, acesse nossa
      <a routerLink="/lgpd">Política de Cookies</a>.
    </p>

    <button class="btn-accept" (click)="accept()">
      Aceitar
    </button>
  </div>
</div>
